'use strict';

import angular from 'angular';

/**
 * Service pour gérer les données des autorisations de recherche
 */
export default angular.module('observatoireApp')
  .service('AutorisationsService', ['$http', '$q', function($http, $q) {
    // Données mockées pour la démonstration - désactivées car nous utilisons les données réelles de l'API
    const autorisationsData = null; /* [
      {
        id: 1,
        denomination: 'PETROCHAD MANGARA',
        referenceContrat: 'Convention Consort Oriental 1999 héritée par la CNPCI',
        reference: '93/PR/PM/MPME/SG/DGP/2015',
        matiereContractee: 'Pétrole et gaz',
        typeAutorisation: 'Autorisation Exclusive de Recherches d\'hydrocarbures liquides et gazeux',
        statut: 'Autorisation expirée',
        projet: 'Projet 2',
        dateDemande: 'Non disponible',
        datePermis: '18/07/2015 00:00:00',
        dateDebutRecherches: 'Non disponible',
        dateExpirationPrevue: '17/07/2020 00:00:00',
        dateExpirationProlongee: 'Non disponible',
        dateResiliation: 'Non disponible',
        dateDerniereModification: 'Non disponible',
        commentaires: 'Arrêté N° 93 /PR/PM/MPME/SG/DGP/2015',
        // Champs additionnels pour les détails
        superficie: 2500,
        province: 'Non disponible',
        departement: 'Non disponible',
        blocPetrolier: 'Non disponible',
        lienReference: 'Non disponible',
        documents: [
          { type: 'Autorisation', nom: 'ARRÊTÉ N° 93/PR/PM/MPME/SG/DGP/2015', url: 'https://www.observatoire.td/documents/ar-2022-001.pdf' }
        ]
      },
      {
        id: 2,
        denomination: 'ESSO EXPLORATION CHAD',
        referenceContrat: 'Convention de Recherche ExxonMobil 2012',
        reference: '127/PR/PM/MPME/SG/DGP/2023',
        matiereContractee: 'Pétrole',
        typeAutorisation: 'Autorisation Exclusive de Recherches d\'hydrocarbures liquides et gazeux',
        statut: 'En vigueur',
        projet: 'Projet Doba Phase 3',
        dateDemande: '15/05/2023',
        datePermis: '2023-07-01 00:00:00',
        dateDebutRecherches: '15/07/2023',
        dateExpirationPrevue: '2028-06-30 00:00:00',
        dateExpirationProlongee: 'Non disponible',
        dateResiliation: 'Non disponible',
        dateDerniereModification: '10/07/2023',
        commentaires: 'Extension du permis initial suite aux découvertes prometteuses',
        superficie: 3200,
        province: 'Mayo-Kebbi',
        departement: 'Mont Illi',
        blocPetrolier: 'KOM',
        lienReference: 'https://www.observatoire.td/autorisations/127-2023'
      },
      {
        id: 3,
        denomination: 'CNPCIC',
        referenceContrat: 'Convention de Partage de Production CNPC 2009',
        reference: '45/PR/PM/MPME/SG/DGP/2021',
        matiereContractee: 'Pétrole et gaz',
        typeAutorisation: 'Autorisation Exclusive de Recherches d\'hydrocarbures liquides et gazeux',
        statut: 'Expiré',
        projet: 'Projet Nord',
        dateDemande: '05/01/2021',
        datePermis: '2021-03-10 00:00:00',
        dateDebutRecherches: '01/04/2021',
        dateExpirationPrevue: '2023-03-09 00:00:00',
        dateExpirationProlongee: 'Non disponible',
        dateResiliation: '15/02/2023',
        dateDerniereModification: '15/02/2023',
        commentaires: 'Autorisation résiliée avant terme pour non-respect des obligations contractuelles',
        superficie: 1800,
        province: 'Tibesti',
        departement: 'Tibesti Est',
        blocPetrolier: 'TIB',
        lienReference: 'https://www.observatoire.td/autorisations/45-2021'
      },
      {
        id: 4,
        denomination: 'GLENCORE EXPLORATION',
        referenceContrat: 'Convention Minière Glencore 2018',
        reference: '76/PR/PM/MPME/SG/DGP/2022',
        matiereContractee: 'Pétrole',
        typeAutorisation: 'Autorisation Exclusive de Recherches d\'hydrocarbures liquides et gazeux',
        statut: 'En vigueur',
        projet: 'Projet Sud-Est',
        dateDemande: '12/06/2022',
        datePermis: '2022-09-15 00:00:00',
        dateDebutRecherches: '01/10/2022',
        dateExpirationPrevue: '2027-09-14 00:00:00',
        dateExpirationProlongee: 'Non disponible',
        dateResiliation: 'Non disponible',
        dateDerniereModification: '30/09/2022',
        commentaires: 'Programme d\'investissement accéléré avec engagement de forage avant 2024',
        superficie: 4100,
        province: 'Logone Oriental',
        departement: 'Nya Pendé',
        blocPetrolier: 'DOI',
        lienReference: 'https://www.observatoire.td/autorisations/76-2022'
      },
      {
        id: 5,
        denomination: 'TOTAL ENERGIES E&P TCHAD',
        referenceContrat: 'Convention d\'Exploitation TotalEnergies 2020',
        reference: '32/PR/PM/MPME/SG/DGP/2023',
        matiereContractee: 'Pétrole et gaz',
        typeAutorisation: 'Autorisation Exclusive de Recherches d\'hydrocarbures liquides et gazeux',
        statut: 'En vigueur',
        projet: 'Projet Lac',
        dateDemande: '05/02/2023',
        datePermis: '2023-03-20 00:00:00',

    // Détails additionnels pour chaque autorisation
    const detailsAutorisations = {};
        ],
        documents: [
          { nom: 'Autorisation de recherche', format: 'PDF', taille: '2.4 MB', date: '2022-02-15' },
          { nom: 'Annexe technique', format: 'PDF', taille: '1.8 MB', date: '2022-02-15' },
          { nom: 'Programme des travaux', format: 'PDF', taille: '3.2 MB', date: '2022-02-15' }
        ],
        historique: [
          { date: '2022-02-01', evenement: 'Signature de l\'autorisation' },
          { date: '2022-02-10', evenement: 'Ratification' },
          { date: '2022-02-15', evenement: 'Entrée en vigueur' }
        ]
      }
    };

    // Générer des détails pour toutes les autorisations
    for (let i = 2; i <= 5; i++) {
      detailsAutorisations[i] = {
        parties: [
          { nom: 'République du Tchad', role: 'État hôte' },
          { nom: autorisationsData.find(a => a.id === i).denomination, role: 'Titulaire' }
        ],
        clauses: [
          { titre: 'Durée', description: 'Autorisation d\'une durée initiale de 5 ans avec possibilité de renouvellement.' },
          { titre: 'Superficie', description: `Superficie totale de ${autorisationsData.find(a => a.id === i).superficie} km² dans la région de ${autorisationsData.find(a => a.id === i).province}.` },
          { titre: 'Programme de travaux', description: `${autorisationsData.find(a => a.id === i).documentsProgramme}.` },
          { titre: 'Investissement minimum', description: `Engagement financier minimum de ${(autorisationsData.find(a => a.id === i).investissementMinimum / 1000000).toFixed(0)} millions USD sur la période.` }
        ],
        documents: [
          { nom: 'Autorisation de recherche', format: 'PDF', taille: '2.1 MB', date: autorisationsData.find(a => a.id === i).datePermis },
          { nom: 'Annexe technique', format: 'PDF', taille: '1.6 MB', date: autorisationsData.find(a => a.id === i).datePermis }
        ],
        historique: [
          { date: autorisationsData.find(a => a.id === i).dateSignature, evenement: 'Signature de l\'autorisation' },
          { date: autorisationsData.find(a => a.id === i).dateRatification, evenement: 'Ratification' },
          { date: autorisationsData.find(a => a.id === i).datePermis, evenement: 'Entrée en vigueur' }
        ]
      };
    }

    /**
     * Récupère la liste des autorisations de recherche
     * @returns {Promise} Promesse contenant les données des autorisations
     */
    this.getAutorisations = function() {
      const deferred = $q.defer();
      
      $http.get('/api/autorisations-recherche')
        .then(function(response) {
          // Traitement des dates si nécessaire
          let autorisations = response.data;
          console.log('Données brutes reçues de l\'API:', JSON.stringify(autorisations, null, 2));
          // Examiner le premier élément en détail s'il existe
          if (autorisations && autorisations.length > 0) {
            console.log('Premier élément détaillé:', JSON.stringify(autorisations[0], null, 2));
            console.log('Type de datePermis:', typeof autorisations[0].datePermis);
            console.log('Valeur de datePermis:', autorisations[0].datePermis);
            console.log('Type de dateExpirationPrevue:', typeof autorisations[0].dateExpirationPrevue);
            console.log('Valeur de dateExpirationPrevue:', autorisations[0].dateExpirationPrevue);
          }
          autorisations.forEach(function(autorisation) {
            // Fonction helper pour convertir une chaîne de date en objet Date valide
            function convertirDate(dateStr) {
              if (!dateStr) return null;
              
              // Si dateStr est déjà un objet Date, le retourner directement
              if (dateStr instanceof Date) {
                return dateStr;
              }
              
              // S'assurer que dateStr est une chaîne de caractères
              const dateString = typeof dateStr === 'string' ? dateStr : String(dateStr);
              
              // Essayer de créer une date valide
              const date = new Date(dateString);
              
              // Vérifier si la date est valide (pas NaN)
              if (!isNaN(date.getTime())) {
                return date;
              }
              
              // Si la date n'est pas au format ISO, essayer d'autres formats
              // Format: yyyy-MM-dd HH:mm:ss
              if (typeof dateString === 'string') {
                const match = dateString.match(/(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2}):(\d{2})/);
                if (match) {
                  return new Date(match[1], match[2]-1, match[3], match[4], match[5], match[6]);
                }
              }
              
              return null;
            }
            
            // Conversion des chaînes de dates en objets Date pour Angular
            autorisation.datePermis = convertirDate(autorisation.datePermis);
            autorisation.dateDemande = convertirDate(autorisation.dateDemande);
            autorisation.dateDebutRecherches = convertirDate(autorisation.dateDebutRecherches);
            autorisation.dateExpirationPrevue = convertirDate(autorisation.dateExpirationPrevue);
            autorisation.dateExpirationProlongee = convertirDate(autorisation.dateExpirationProlongee);
            autorisation.dateResiliation = convertirDate(autorisation.dateResiliation);
            autorisation.dateDerniereModification = convertirDate(autorisation.dateDerniereModification);
          });
          
          deferred.resolve(autorisations);
        })
        .catch(function(error) {
          console.error('Erreur lors du chargement des autorisations:', error);
          // En cas d'erreur, on renvoie un tableau vide au lieu des données mockées
          deferred.resolve([]);
        });
      
      return deferred.promise;
    };

    /**
     * Récupère les détails d'une autorisation spécifique
     * @param {number} id Identifiant de l'autorisation
     * @returns {Promise} Promesse contenant les détails de l'autorisation
     */
    this.getAutorisationDetails = function(id) {
      const deferred = $q.defer();
      
      $http.get(`/api/autorisations-recherche/${id}`)
        .then(function(response) {
          // Traitement des dates si nécessaire
          let autorisation = response.data;
          
          // Fonction helper pour convertir une chaîne de date en objet Date valide
          function convertirDate(dateVal) {
            console.log('Conversion de date:', dateVal, 'type:', typeof dateVal);
            
            if (!dateVal) {
              console.log('  -> date nulle ou vide');
              return null;
            }
            
            // Si dateVal est déjà un objet Date, le retourner directement
            if (dateVal instanceof Date) {
              console.log('  -> déjà un objet Date');
              return dateVal;
            }
            
            // IMPORTANT: Gérer le cas où dateVal est un tableau [année, mois, jour, ...]
            // Format renvoyé par le backend Spring: [2015, 7, 18, 0, 0]
            if (Array.isArray(dateVal)) {
              console.log('  -> format tableau détecté:', dateVal);
              // ATTENTION: dans les tableaux, le mois est 1-indexed, mais dans Date() il est 0-indexed
              // Donc on soustrait 1 du mois pour le constructeur Date
              const moisIndex = dateVal[1] - 1; 
              return new Date(dateVal[0], moisIndex, dateVal[2], dateVal[3] || 0, dateVal[4] || 0);
            }
            
            // S'assurer que dateVal est une chaîne de caractères pour les formats textuels
            const dateString = typeof dateVal === 'string' ? dateVal : String(dateVal);
            console.log('  -> convertie en chaîne:', dateString);
            
            // Format: yyyy-MM-dd
            if (typeof dateString === 'string') {
              const simpleDateMatch = dateString.match(/(\d{4})-(\d{2})-(\d{2})/);
              if (simpleDateMatch) {
                console.log('  -> format yyyy-MM-dd détecté');
                return new Date(simpleDateMatch[1], simpleDateMatch[2]-1, simpleDateMatch[3]);
              }
            }
            
            // Format: yyyy-MM-dd HH:mm:ss
            if (typeof dateString === 'string') {
              const match = dateString.match(/(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2}):(\d{2})/);
              if (match) {
                console.log('  -> format yyyy-MM-dd HH:mm:ss détecté');
                return new Date(match[1], match[2]-1, match[3], match[4], match[5], match[6]);
              }
            }
            
            // Essayer le constructeur Date standard en dernier recours
            const date = new Date(dateString);
            
            // Vérifier si la date est valide (pas NaN)
            if (!isNaN(date.getTime())) {
              console.log('  -> date valide avec constructeur standard');
              return date;
            }
            
            console.log('  -> impossible de convertir la date');
            return null;
          }
          
          // Conversion des chaînes de dates en objets Date pour Angular
          autorisation.datePermis = convertirDate(autorisation.datePermis);
          autorisation.dateDemande = convertirDate(autorisation.dateDemande);
          autorisation.dateDebutRecherches = convertirDate(autorisation.dateDebutRecherches);
          autorisation.dateExpirationPrevue = convertirDate(autorisation.dateExpirationPrevue);
          autorisation.dateExpirationProlongee = convertirDate(autorisation.dateExpirationProlongee);
          autorisation.dateResiliation = convertirDate(autorisation.dateResiliation);
          autorisation.dateDerniereModification = convertirDate(autorisation.dateDerniereModification);
          
          // Pour les documents dans la collection
          if (autorisation.documents) {
            autorisation.documents.forEach(function(doc) {
              if (doc.date) doc.date = new Date(doc.date);
            });
          }
          
          // Ne pas utiliser de données mockées
          // S'assurer que les propriétés existent pour éviter les erreurs dans le frontend
          if (!autorisation.clauses) {
            autorisation.clauses = [];
          }
          
          if (!autorisation.historique) {
            autorisation.historique = [];
          }
          
          deferred.resolve(autorisation);
        })
        .catch(function(error) {
          console.error(`Erreur lors du chargement des détails de l'autorisation ${id}:`, error);
          // En cas d'erreur, on essaie de renvoyer les données mockées comme fallback
          const autorisation = autorisationsData.find(a => a.id === parseInt(id, 10));
          const details = detailsAutorisations[id] || {};
          
          if (autorisation) {
            // Combiner l'autorisation et ses détails
            const autorisationDetails = {
              ...autorisation,
              parties: details.parties || [],
              clauses: details.clauses || [],
              documents: details.documents || [],
              historique: details.historique || []
            };
            
            deferred.resolve(autorisationDetails);
          } else {
            deferred.reject('Autorisation non trouvée');
          }
        });
      
      return deferred.promise;
    };
    
    /**
     * Exporte les autorisations au format Excel (XLSX)
     * @param {Array} autorisations Liste des autorisations à exporter
     * @returns {Promise}
     */
    this.exporterAutorisations = function(autorisations) {
      return $q.when(import('../utils/excel-export.js')).then(function(module) {
        const lignes = (autorisations || []).map(function(a) {
          return {
            'Dénomination': a.denomination || '',
            'Référence': a.reference || '',
            'Contrat de référence': a.referenceContrat || '',
            'Matière contractée': a.matiereContractee || '',
            "Type d'autorisation": a.typeAutorisation || '',
            'Statut': a.statut || '',
            'Date du permis': a.datePermis ? String(a.datePermis).substring(0, 10) : '',
            "Date d'expiration prévue": a.dateExpirationPrevue ? String(a.dateExpirationPrevue).substring(0, 10) : '',
            'Superficie (km²)': a.superficie || '',
            'Document': a.lienReference || ((a.documents || [])[0] || {}).url || ''
          };
        });
        return module.default.exportToExcel(lignes, 'autorisations_recherche.xlsx');
      });
    };
  }]);
